import { useQuery } from 'react-query';

import { useSessionStore } from 'session/useSessionStore';
import { axios } from 'configurations/axios';

export function useGetTextForViewer(url: string | undefined) {
    const { jwtToken } = useSessionStore(state => ({
        jwtToken: state.jwtToken
    }));

    return useQuery(['getTextForViewer', url], async () => {
        const response = await axios.get(url!, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${jwtToken}`
            },
        });

        return response.data;
    }, {
        refetchOnWindowFocus: false,
        enabled: !!url && !!jwtToken,
    });
}
